import React, { useState } from "react";
import MaterialTable from "material-table";
import { IItem } from "./OutOfFlash";

// Material UI
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";

const tableIcons = {
  Add: AddBox,
  Check: Check,
  Clear: Clear,
  Delete: DeleteOutline,
  DetailPanel: ChevronRight,
  Edit: Edit,
  Export: SaveAlt,
  Filter: FilterList,
  FirstPage: FirstPage,
  LastPage: LastPage,
  NextPage: ChevronRight,
  PreviousPage: ChevronLeft,
  ResetSearch: Clear,
  Search: Search,
  SortArrow: ArrowDownward,
  ThirdStateCheck: Remove,
  ViewColumn: ViewColumn,
};

export default ({
  rows,
  refresh,
  isLoading,
}: {
  rows: IItem[];
  refresh: () => void;
  isLoading: boolean;
}) => {
  const columns = [
    {
      title: "Application Name",
      field: "name",
      lookup: rows.reduce((curr: { [index: string]: string }, row) => {
        curr[row.name] = row.name;
        return curr;
      }, {}),
    },
    {
      title: "Model",
      field: "model",
      lookup: rows.reduce((curr: { [index: string]: string }, row) => {
        curr[row.model] = row.model;
        return curr;
      }, {}),
    },
    { title: "SWID", field: "swid" },
    { title: "Date Uploaded", field: "uploaded", filtering: false },
    { title: "Signed", field: "signed", type: "boolean" as any },
  ];
  const [appData, openConfirmDialog] = useState({ open: false, row: {} });
  return (
    <>
      <MaterialTable
        isLoading={isLoading}
        actions={[
          {
            icon: () => <DeleteOutline />,
            tooltip: "Delete File",
            onClick: (event, rowData: any) =>
              openConfirmDialog({ open: true, row: rowData }),
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          emptyRowsWhenPaging: false,
          filtering: true,
          search: false,
          showTitle: false,
          toolbar: false,
        }}
        icons={tableIcons}
        columns={columns}
        data={rows}
      />
      <Dialog open={appData.open}>
        <DialogTitle id="form-dialog-title">Delete File</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => openConfirmDialog({ open: false, row: {} })}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (appData.row.key) {
                fetch(`/api/file/${encodeURIComponent(appData.row.key)}`, {
                  method: "DELETE",
                }).then(() => refresh());
              }
              openConfirmDialog({ open: false, row: {} });
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
